import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="login-page"
      className="min-h-screen bg-[#050505] text-[#F4F4F5] noise flex items-center justify-center p-6 relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-[-20%] left-[-10%] w-[500px] h-[500px] bg-[#FF3E00] rounded-full blur-[120px]" />
      </div>
      <div className="relative w-full max-w-md">
        <Link to="/" className="font-display text-2xl font-black uppercase">
          ELARTE<span className="text-[#FF3E00]">/</span>NET
        </Link>

        <div className="font-mono text-[10px] text-[#FF3E00] tracking-[0.3em] mt-10 mb-2">
          INGRESAR
        </div>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter uppercase leading-[0.9]">
          Vuelve al
          <br />
          <span className="text-[#FF3E00]">estudio</span>.
        </h1>

        <form onSubmit={onSubmit} className="mt-10 space-y-5">
          <div>
            <label className="font-mono text-[10px] text-[#A1A1AA] tracking-[0.22em]">
              // EMAIL
            </label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-2 w-full bg-[#0a0a0a] border border-[#27272A] focus:border-[#FF3E00] focus:outline-none p-3 font-display text-[15px] placeholder:text-[#525252]"
              placeholder="tu@correo.com"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] text-[#A1A1AA] tracking-[0.22em]">
              // CONTRASEÑA
            </label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-2 w-full bg-[#0a0a0a] border border-[#27272A] focus:border-[#FF3E00] focus:outline-none p-3 font-display text-[15px] placeholder:text-[#525252]"
              placeholder="••••••••"
            />
          </div>

          {error ? (
            <div
              data-testid="login-error"
              className="border border-[#FF0033] bg-[#FF0033]/10 px-3 py-2 font-mono text-[11px] text-[#FF8899] tracking-wider"
            >
              {error}
            </div>
          ) : null}

          <button
            data-testid="login-submit"
            type="submit"
            disabled={submitting}
            className={`btn-brutal w-full font-mono uppercase text-xs tracking-[0.22em] font-bold py-3 mt-4 ${
              submitting
                ? "bg-[#121212] text-[#525252] cursor-not-allowed"
                : "bg-[#FF3E00] text-white"
            }`}
          >
            {submitting ? "Entrando…" : "→ Entrar"}
          </button>
        </form>

        <div className="mt-6 border border-[#27272A] bg-[#0a0a0a] p-3 font-mono text-[10px] text-[#A1A1AA] tracking-wider">
          DEMO · admin@elarte.net / elarte2026
        </div>

        <p className="mt-8 font-mono text-[11px] text-[#A1A1AA]">
          ¿Aún no tienes cuenta?{" "}
          <Link to="/registro" className="text-[#FF3E00] hover:text-white">
            Regístrate
          </Link>
        </p>
      </div>
    </div>
  );
}
